export default function InputCheckBox2({ name, id, label, value, setValue }) {
    return (
      <div
        id={id}
        style={{
          display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                padding: "10px",
                borderRadius: "4px"
        }}
      >
        <input
          type="checkbox"
          name={name}
          id={id}
          style={{
            minHeight: "16px",
            minWidth: "16px",
            accentColor: "#514C9F",
            borderRadius: "4px"
          }}
          checked={!!value}
          onChange={(e) => setValue(e.target.checked)}
        />
  
        <label htmlFor={id} style={{ userSelect: "none", cursor: "pointer" }}>
          I consent to the following:
          {/* <a
            href="https://www.carepay.money/TermsAndConditions"
            target="_blank"
            rel="noopener noreferrer"
            className="termsAndCond"
            style={{
              textDecoration: "underline",
              fontWeight: "600",
              color: "#514C9F"
            }}
          >
            Terms & Conditions
          </a>{" "}
          and{" "}
          <a
            href="https://www.carepay.money/privacyPolicy"
            target="_blank"
            rel="noopener noreferrer"
            className="termsAndCond"
            style={{
              textDecoration: "underline",
              fontWeight: "600",
              color: "#514C9F"
            }}
          >
            Privacy Policy
          </a>
          . */}
        </label>
      </div>
    );
  }
  